<template>
    <el-row class="userinfo-wrapper">
        <el-col :span="6">
            <basic-container class="tac">
                <el-image class="logo" :src="deptDetail.avatar" fit="contain"></el-image>
                <div class="u-title">{{deptDetail.deptName}}</div>
                <div>海纳百川，有容乃大</div>
                <div class="user-info-item">
                    <div class="item" v-for="(item,index) in deptList" :key="index"><span class="el-icon-c-scale-to-original mr5"></span>{{item.title}}</div>
                </div>
            </basic-container>
        </el-col>
        <el-col :span="18">
            <basic-container>
                <avue-tabs :option="option" @change="handleChange"></avue-tabs>
                <div v-if="type.prop==='tab1'">
                    <avue-notice @click="handleClick" :data="dynamicList" :option="option1" @page-change="pageChange1"></avue-notice>
                </div>
                <div v-else-if="type.prop==='tab2'">
                    <deskOrder></deskOrder>
                </div>
                <div v-else-if="type.prop==='tab3'">
                    <avue-notice @click="seeDetailHandle" :data="infoList" :option="option1" @page-change="pageChange"></avue-notice>
                    <!-- <avue-data-imgtext :option="option3"></avue-data-imgtext> -->
                </div>
            </basic-container>
        </el-col>
        <el-dialog title="工作信息详情" fullscreen append-to-body width="80%" :visible.sync="infoDetailVisible">
            <see :info="detail"></see>
        </el-dialog>
    </el-row>
</template>
<script>
import { mapGetters } from "vuex";
import { getDept, getDeptLazyTree } from '@/api/system/dept'
import { getUserInfo } from "@/api/system/user";
import deskOrder from '@/views/desk/components/desk-order.vue'
import { getList } from "@/api/job/jobinformation";
import { starorderconfirmrecordList } from '@/api/desk/index'
import { getDetail } from "@/api/job/jobinformation";
import see from "@/views/job/see.vue";
export default {
    data() {
        return {
            type: {},
            option: {
                column: [{
                    label: '机构信息',
                    prop: 'tab1',
                }, {
                    label: '待办提醒',
                    prop: 'tab2',
                }, {
                    label: '工作信息',
                    prop: 'tab3',
                }]
            },
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            option1: {
                props: {
                    img: 'img',
                    title: 'title',
                    subtitle: 'createTime',
                    status: 'status'
                },
            },
            infoList: [],
            dynamicList: [],
            page1: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            activeName: 'first',
            option3: {
                data: []
            },
            detail:{},
            infoDetailVisible:false,
            deptDetail: {},
            deptList: []
        };
    },
    components: {
        deskOrder,
        see
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    created() {
        this.type = this.option.column[0];
    },
    mounted() {
        getUserInfo().then(res => {
            this.deptDetail = res.data.data;
        });
        // getDept(this.userInfo.dept_id).then(res => {
        //     this.deptDetail = res.data.data

        // })
        getDeptLazyTree(this.userInfo.dept_id).then(res => {
            this.deptList = res.data.data
        })
        this.infoList = []
        this.onLoad(this.page)
        this.dynamicList = []
        this.onLoad1()
    },
    methods: {
        handleChange(column) {
            this.type = column
            // this.$message.success(JSON.stringify(column))
        },
        seeDetailHandle(row) {
            getDetail(row.id).then((res) => {
                this.detail = res.data.data;
                this.infoDetailVisible = true;
            });
        },
        handleClick(item) {
            // this.$message.success(JSON.stringify(item))
        },
        onLoad(page) {
            let column = this.findObject(this.option.column, "tab3")
            getList(page.currentPage, page.pageSize).then(res => {
                const data = res.data.data;
                this.page.total = data.total;
                this.infoList = data.records;
                column.label = "工作信息(" + (res.data.data.total == 0 ? '' : res.data.data.total)+")"
            });
        },
        pageChange(page, done) {
            if (this.page.total == this.infoList.length) {
                this.$message.error("没有更多了")
                done()
                return;
            }
            this.page.currentPage = page
            getList(this.page.currentPage, this.page.pageSize).then(res => {
                const data = res.data.data;
                this.page.total = data.total;
                this.infoList = this.infoList.concat(data.records);
                done();
            });
        },

        onLoad1() {
            let column = this.findObject(this.option.column, "tab1")
            starorderconfirmrecordList(this.page1.currentPage, this.page1.pageSize).then(res => {
                this.dynamicList = res.data.data.records
                this.page1.total = res.data.data.total

                column.label = "机构信息" + (res.data.data.total == 0 ? '' : res.data.data.total)
            })
        },
        pageChange1(page, done) {
            if (this.page1.total == this.dynamicList.length) {
                this.$message.error("没有更多了")
                done()
                return;
            }
            this.page1.currentPage = page
            getList(this.page1.currentPage, this.page1.pageSize).then(res => {
                const data = res.data.data;
                this.page1.total = data.total;
                this.dynamicList = this.dynamicList.concat(data.records);
                done();
            });
        },



    }
};

</script>
<style lang="scss">
.userinfo-wrapper {
    .logo {
        margin-top: 30px;
        width: 90px;
        height: 90px;
    }

    .u-title {
        margin: 20px 0 5px;
        color: #000;
        font-size: 16px;
        font-weight: bold;
    }

    .user-info-item {
        margin-top: 40px;
        text-align: left;

        .item {
            padding: 10px 0;

        }
    }

    .avue-data-imgtext .item {
        width: 90% !important;
    }

    .avue-crud__menu {
        display: none;
    }
}

</style>
